import React from "react";
import { render } from "react-snapshot";
import "./style/main.css";
import LoginPage from "./auth/LoginPage";
import LoginSuccessPage from "./auth/LoginSuccessPage";
import LogoutPage from "./auth/LogoutPage";
import SignupPage from "./signup/SignupPage";
import NotFoundPage from "./NotFoundPage";
import PendingAccountPage from "./signup/PendingAccountPage";
import ActivateAccountPage from "./signup/ActivateAccountPage";
import AccountActivatedPage from "./signup/AccountActivatedPage";
import Terms from "./content/Terms.js";
import Privacy from "./content/Privacy.js";
import PlansPage from "./PlansPage.js";
import VisitRankPage from "./VisitRankPage.js";
import Helmet from "react-helmet";
import SearchPage from "./SearchPage";
import { Router, Route, browserHistory, IndexRedirect } from "react-router";
import App from './App';
import Consulting from "./Consulting";
import ListsPage from "./ListsPage";
import CloudPage from "./CloudPage";
import LandingPage from "./LandingPage";
import mixpanel from 'mixpanel-browser';
import DashboardPage from './DashboardPage';

mixpanel.init("0f24f5e7f212fa7f76aa53148f0362d6");

browserHistory.listen(function(location) {
	mixpanel.track('View: ' + location.pathname, {		
		url: location.pathname,
		query: location.query
	});
	window.ga('send', 'pageview', location.pathname);
	window.scrollTo(0, 0);
});

render(
	<div>
		<Helmet 
			titleTemplate="%s | Webfinery | Web Data Intelligence"
			defaultTitle="Webfinery | Web Data Intelligence">
			<meta name="description" content="Search the source code of the web. Used by professionals in Sales, Marketing, Growth, Security and Web Data Research."/>        	
			<html lang="en"/>			
		</Helmet>

	    <Router history={browserHistory}>
	    	<Route path="/" component={App}>
	    		<IndexRedirect to="/home" />
	    		<Route path="/home" component={LandingPage} />
	    		<Route path="/dashboard" component={DashboardPage} />
	    		<Route path="/cloud" component={CloudPage} />
	    		<Route path="/cloud/visitrank" component={VisitRankPage} />
	            <Route path="/search" component={SearchPage} />
	            <Route path="/lists" component={ListsPage} />
	            <Route path="/consulting" component={Consulting} />
	            <Route path="/login" component={LoginPage} />
	            <Route path="/login/success" component={LoginSuccessPage} />
	            <Route path="/signup" component={SignupPage} />
	            <Route path="/signup/activate" component={ActivateAccountPage} />
	            <Route path="/signup/pending" component={PendingAccountPage} />
	            <Route path="/signup/activated" component={AccountActivatedPage} />
	            <Route path="/logout" component={LogoutPage} />
	            <Route path="/terms" component={Terms} />
	            <Route path="/privacy" component={Privacy} />
	            <Route path="/search/plans" component={PlansPage} />
	            <Route path="*" component={NotFoundPage}/>
	        </Route>
	    </Router>
    </div>,
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js